import { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { Box, Paper, Text } from 'ui/baseComponents'
import { ROUTE_METADATA } from 'app/AppRoutes/RouteMetadata'
import CookieBanner from 'ui/components/CookieBanner/CookieBanner'
import ErrorBoundary from 'ui/components/ErrorBoundary'
import FixedWidthLayout from 'ui/components/FixedWidthLayout'
import InviteUsers from './InviteUsers'
import { useIsAdmin } from 'ui/hooks'
import UserPHIContext from 'ui/contexts/UserPHIContext'
import PageHeader from 'ui/templates/PageHeader'
import MainContentWrapper from 'ui/templates/MainContentWrapper'
import MainContent from 'ui/templates/MainContent'
import MainNav from 'ui/components/MainNav'
import { colors } from 'theme/colors'
import UserTable from 'ui/screens/Users/UserTable/UserTable'

const STYLES = {
  usersTableBox: {
    paddingTop: '1rem',
    backgroundColor: colors.COOL[100],
  },
  usersTableSubBox: {
    padding: '0 10%',
    overflowX: 'scroll',
    '@media (max-width: 1200px)': {
      padding: '0',
    },
  },
}

/**
 * The main container component for the user view
 *
 * @returns {JSX.Element} The container component
 */
export const Users = () => {
  const { admin } = useIsAdmin()
  const phiVisibility = useContext(UserPHIContext)

  // type check is required for the brief instant that admin could be undefined
  if (typeof admin === 'boolean' && !admin) {
    return <Navigate to={ROUTE_METADATA.patients.path} replace />
  }

  if (phiVisibility) {
    return (
      <>
        <MainNav />
        <PageHeader
          title={
            <Text component="h1" variant="head42">
              Team
            </Text>
          }
          contentRight={<InviteUsers />}
        />
        <MainContentWrapper>
          <ErrorBoundary>
            <Box sx={STYLES.usersTableBox}>
              <MainContent>
                <Box sx={STYLES.usersTableSubBox}>
                  <UserTable />
                </Box>
              </MainContent>
            </Box>
          </ErrorBoundary>
        </MainContentWrapper>
        <CookieBanner />
      </>
    )
  } else {
    return (
      <>
        <FixedWidthLayout>
          <ErrorBoundary>
            <InviteUsers />
            <Paper>
              <UserTable />
            </Paper>
          </ErrorBoundary>
        </FixedWidthLayout>
        <CookieBanner />
      </>
    )
  }
}

export default Users
